"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyStatusConfirmation = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var shared_styles_1 = require("./shared-styles");
var Icon_1 = require("../Icon");
var usePermissionsModalContext_1 = require("./usePermissionsModalContext");
var PrivacyStatusConfirmation = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, privacyStatusMutation = _a.privacyStatusMutation, newPrivacyStatus = _a.newPrivacyStatus, topIcon = _a.topIcon, headingText = _a.headingText, message = _a.message, confirmButtonOptions = _a.confirmButtonOptions;
    var _js = (0, usePermissionsModalContext_1.usePermissionsModalContext)()._js;
    var cancelRef = React.useRef(null);
    var confirmButtonIcon = confirmButtonOptions.icon, confirmButtonText = confirmButtonOptions.text, confirmButtonProps = __rest(confirmButtonOptions, ["icon", "text"]);
    return (React.createElement(react_1.AlertDialog, { isOpen: isOpen, leastDestructiveRef: cancelRef, onClose: onClose },
        React.createElement(react_1.AlertDialogOverlay, null,
            React.createElement(react_1.AlertDialogContent, { h: "calc(".concat(shared_styles_1.MODAL_HEIGHT, " * 3/4)"), maxH: shared_styles_1.MODAL_MAX_HEIGHT, w: { base: '100%', sm: "calc(".concat(shared_styles_1.MODAL_HEIGHT, " * 3/4)") }, mt: "calc(var(--chakra-space-16) + ".concat(shared_styles_1.MODAL_HEIGHT, " * 1/8)"), px: { base: 5, sm: 4 }, py: { base: 8, sm: 4 }, borderRadius: "lg", "data-testid": "permissions-modal-privacy-status-confirmation" },
                React.createElement(Icon_1.Icon, { type: topIcon, mx: "auto", size: "2x" }),
                React.createElement(react_1.Heading, { textAlign: "center", as: "h2", size: "md", mt: 3, border: "none" }, headingText),
                React.createElement(react_1.Text, { align: "center", mt: 3, fontWeight: 400, px: 4, lineHeight: 5 }, message),
                React.createElement(react_1.Flex, { direction: "column", mt: "auto" },
                    React.createElement(react_1.Button, __assign({}, confirmButtonProps, { leftIcon: React.createElement(Icon_1.Icon, { type: confirmButtonIcon }), onClick: function () {
                            return privacyStatusMutation.mutate({ privacyStatus: newPrivacyStatus });
                        }, isLoading: privacyStatusMutation.isLoading, "data-testid": "permissions-modal-set-privacy-status-button" }), confirmButtonText),
                    React.createElement(react_1.Button, { ref: cancelRef, onClick: onClose, mt: 2 }, _js('Cancel')))))));
};
exports.PrivacyStatusConfirmation = PrivacyStatusConfirmation;
